<ng-container *transloco="let tr; prefix: 'workflows'; scope: 'workflows'">
  <nz-affix [nzOffsetTop]="0">
    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>{{tr('title')}}</nz-page-header-title>
      <nz-page-header-subtitle>{{tr('subTitle')}}</nz-page-header-subtitle>
      <nz-page-header-extra>
        <a routerLink="new" nz-button nzType="primary">
          <i nz-icon nzType="plus-circle" nzTheme="outline"></i> {{'button.addNew' | transloco}}
        </a>
      </nz-page-header-extra>
    </nz-page-header>
  </nz-affix>

  <nz-collapse nzBordered="false">
    <nz-collapse-panel [nzHeader]="'filters' | transloco" [nzActive]="true">
      <div nz-row [nzGutter]="[16,24]">
        <div nz-col>
          <small>{{tr('filter.query')}}</small>
          <input nz-input [(ngModel)]="filter.query" (ngModelChange)="applyFilters(500)">
        </div>
        <div nz-col>
          <small>{{tr('filter.query')}}</small>
          <hx-workflow-category-select [(ngModel)]="filter.workflowCategoryId" (ngModelChange)="applyFilters()"></hx-workflow-category-select>
        </div>
        <div nz-col>
          <small>{{tr('filter.query')}}</small>
          <hx-store-select [(ngModel)]="filter.storeId" (ngModelChange)="applyFilters()"></hx-store-select>
        </div>
      </div>
      <div nz-row [nzGutter]="[16,24]">
        <div nz-col>
          <button nz-button nzType="default" (click)="reset()">
            <i nz-icon nzTheme="outline"></i> {{'button.reset' | transloco}}
          </button>
        </div>
      </div>
    </nz-collapse-panel>
  </nz-collapse>

  <nz-table [nzLoading]="isTableLoading" #listTable
            [nzTotal]="total"
            [nzPageSize]="limit"
            [nzPageIndex]="page"
            [nzData]="list"
            (nzQueryParams)="onQueryParamsChange($event)"
            [nzFrontPagination]="false">
    <thead>
    <tr>
      <th>{{tr('column.title')}}</th>
      <th>{{tr('column.description')}}</th>
      <th>{{tr('column.category')}}</th>
      <th nzWidth="100px">#</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of listTable.data">
      <td>
        <a [routerLink]="data.id + '/steps'">
          {{ data.title | uiLabel }}
        </a>
      </td>
      <td>
        {{ data.description }}
      </td>
      <td>
        {{ categoryTitleMap.get(data.workflowCategoryId) | uiLabel }}
      </td>
      <td>
        <nz-button-group>
          <a [routerLink]="data.id + '/edit'" nz-button nzType="primary">
            <i nz-icon nzType="edit" nzTheme="outline"></i>
          </a>
          <button nz-button nzType="default" nzDanger nz-popconfirm
                  [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                  [nzCancelText]="'no1' | transloco"
                  (nzOnConfirm)="remove(data.id)">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
          </button>
        </nz-button-group>
      </td>
    </tr>
    </tbody>
  </nz-table>
</ng-container>
